import { MenuActionType } from "./actionState";
import { MenuActionTypes } from "./actionTypes";

export const menuActions: MenuActionType = {};
